export enum DomainErrorCode {
  // =========================== COMMON ERROR CODE ===========================
  BAD_REQUEST_ERROR = "BAD_REQUEST_ERROR",
  UNEXPECTED_ERROR = "UNEXPECTED_ERROR",
  FORBIDDEN_ERROR = "FORBIDDEN_ERROR",
  VALIDATION_FAILED_ERROR = "VALIDATION_FAILED_ERROR",
  FIELD_MISSING_ERROR = "FIELD_MISSING_ERROR",
  NOT_FOUND_ERROR = "NOT_FOUND_ERROR",
  FILE_UPLOAD_ERROR = "FILE_UPLOAD_ERROR",
  TRANSPORT_ERROR = "TRANSPORT_ERROR",
  INVALID_ARGUMENT_ERROR = "INVALID_ARGUMENT_ERROR",

  // =========================== DEVICE ERROR CODE ===========================
  DEVICE_NOT_FOUND_ERROR = "DEVICE_NOT_FOUND_ERROR",
  DEVICE_ALREADY_ON_SITE_ERROR = "DEVICE_ALREADY_ON_SITE_ERROR",
  DEVICE_NOT_LINKED_TO_SITE_ERROR = "DEVICE_NOT_LINKED_TO_SITE_ERROR",
  DEVICE_HAS_WRONG_TYPE_ERROR = "DEVICE_HAS_WRONG_TYPE_ERROR",
  DEVICE_HAS_NO_HW_LINK_ERROR = "DEVICE_HAS_NO_HW_LINK_ERROR",
  VX_UNKNOWN_DEVICE_ERROR = "VX_UNKNOWN_DEVICE_ERROR",
  GATEWAY_NOT_LINKED_TO_SITE_ERROR = "GATEWAY_NOT_LINKED_TO_SITE_ERROR",
  GATEWAY_UNAVAILABLE_ERROR = "GATEWAY_UNAVAILABLE_ERROR",
  DEVICE_HAS_WRONG_MODE_ERROR = "DEVICE_HAS_WRONG_MODE_ERROR",
  COMMUNICATION_STATE_NOT_FOUND_ERROR = "COMMUNICATION_STATE_NOT_FOUND_ERROR",
  GATEWAY_UPDATE_FAILED_ERROR = "GATEWAY_UPDATE_FAILED_ERROR",

  // =========================== OPERATION ERROR CODE ===========================
  MISSING_OPERATOR_COMPANY_ERROR = "MISSING_OPERATOR_COMPANY_ERROR",
  OPERATION_NOT_FOUND_ERROR = "OPERATION_NOT_FOUND_ERROR",
  SITE_OPERATION_LINK_NOT_FOUND_ERROR = "SITE_OPERATION_LINK_NOT_FOUND_ERROR",
  SITE_HAS_MULTIPLE_MISSIONS_ERROR = "SITE_HAS_MULTIPLE_MISSIONS_ERROR",
  SITE_IS_ATTACHED_TO_MULTIPLE_OPERATIONS_ERROR = "SITE_IS_ATTACHED_TO_MULTIPLE_OPERATIONS_ERROR",
  OPERATION_MISSION_NOT_FOUND_ERROR = "OPERATION_MISSION_NOT_FOUND_ERROR",
}

export class DomainError extends Error {
  constructor(
    public readonly errorCode: DomainErrorCode,
    message?: string | null,
  ) {
    super(message ?? "/");
  }
}

export class DomainTransportError extends DomainError {
  constructor(message?: string) {
    super(DomainErrorCode.TRANSPORT_ERROR, message);
  }
}

export class DomainUnauthorizedError extends DomainError {
  constructor() {
    super(DomainErrorCode.FORBIDDEN_ERROR);
  }
}

export class DomainNotFoundError extends DomainError {
  constructor(message?: string) {
    super(DomainErrorCode.NOT_FOUND_ERROR, message ?? "not found");
  }
}

export class DomainInvalidArgumentError extends DomainError {
  constructor(message?: string) {
    super(DomainErrorCode.INVALID_ARGUMENT_ERROR, message ?? "Invalid argument");
  }
}
